import React from 'react';
import PropTypes from 'prop-types';
import SrInfoOptionCheckbox from 'client/components/SrInfoOptionCheckbox/SrInfoOptionCheckbox';

export const SR_CHECKBOX_LIST_LAYOUT_NO_WRAP = 'noGridWrap';
export const SR_CHECKBOX_LIST_THEME_BULLET_GRID = 'bulletGrid';

class SrInfoOptionCheckboxList extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    optionList: PropTypes.array.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
      PropTypes.bool,
    ]),
  }

  static defaultProps = {
    value: [],
  }

  _onChangeCheckbox = (formValue) => {
    const {
      onChange,
    } = this.props;

    onChange(formValue);
  }

  render() {
    const {
      optionList,
      value,
    } = this.props;

    return (
      <div>
        {optionList.map((option) => (
          <SrInfoOptionCheckbox
            collapseUnselected={value}
            key={option.value}
            isActive={value === option.value}
            onClick={() => {
              this._onChangeCheckbox(option.value);
              if (option.onClick) option.onClick();
            }}
            tagTheme={option.tagTheme}
            tagContents={option.tagContents}
            title={option.label}
            description={option.description}
          />
        ))}
      </div>
    );
  }
}

SrInfoOptionCheckboxList.displayName = 'SrInfoOptionCheckboxList';

export default SrInfoOptionCheckboxList;
